import type { Watch } from '@/views/MyWatchesView';

import { MyWatchCard } from '../../../MyWatchCard';

import * as S from './MyWatchesGrid.styles';

export interface MyWatchesGridProps {
  onRegisterWatchClick: () => void;
  watches: Watch[];
}

export const MyWatchesGrid = ({ watches }: MyWatchesGridProps) => {
  return (
    <S.InnerWrapper data-test-id='MyWatchesGridInnerWrapper'>
      {watches.map((watch, index) => (
        <MyWatchCard
          key={watch.sn}
          data-test-id={`MyWatchesGridMyWatchCard-${index}`}
          watch={watch}
        />
      ))}
    </S.InnerWrapper>
  );
};

MyWatchesGrid.displayName = 'MyWatchesGrid';
